import AddOpportunity from "./AddOpportunity";

export default AddOpportunity;



// WEBPACK FOOTER //
// ./src/components/AddOpportunity/index.js